// extracted by mini-css-extract-plugin
module.exports = {"test":"photoArray-module--test--1OeIx"};